<template>
  <page title="Reports">
    <template #actions>
      <div>
        <text-field
          v-model="search"
          label="Search Reports"
          class="full-width report-search"
          type="search"
        ></text-field>
      </div>
    </template>
    <div class="groups-cont">
      <div v-for="(group, name) in filteredGroups" :key="name">
        <div>
          <h2 class="page-header-2">
            <i
              v-if="group.icon"
              :class="['text-secondary category-icon', group.icon]"
              class="mr-2"
            ></i
            >{{ name }}
          </h2>
          <accordion :items="group.reports" class="mt-4">
            <template #header="{ item }">
              <a :href="item.url" data-no-toggle>{{ item.name }}</a>
            </template>
            <template #content="{ item }">
              <div v-if="item.details.length">
                <ul class="details-list">
                  <li v-for="detail in item.details" :key="detail">
                    {{ detail }}
                  </li>
                </ul>
              </div>
            </template>
          </accordion>
          <div v-if="!group.reports.length" class="text-center text-secondary">
            No Reports Available
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import { mapActions } from "vuex";

import Card from "@/components/Card.vue";
import Page from "@/components/Page.vue";
import TextField from "@/components/TextField.vue";

export default {
  components: { Page, Card, TextField },
  data() {
    return {
      reportGroups: {},
      search: null
    };
  },
  computed: {
    filteredGroups() {
      if (!this.search) {
        return this.reportGroups;
      }
      return Object.keys(this.reportGroups).reduce(
        (filteredGroups, groupKey) => {
          const group = this.reportGroups[groupKey];
          // Add group key
          if (!filteredGroups[groupKey]) {
            filteredGroups[groupKey] = { ...group, reports: [] };
          }
          // Check if the report name or any questions contain search
          const matchedReports = group.reports.filter(
            (report) =>
              this.containsSearch(report.name) ||
              report.details.some((detail) => this.containsSearch(detail))
          );
          // Add matched reports to filtered object
          if (matchedReports) {
            filteredGroups[groupKey].reports =
              filteredGroups[groupKey].reports.concat(matchedReports);
          }
          return filteredGroups;
        },
        {}
      );
    }
  },
  mounted() {
    this.fetchReportGroups().then((res) => (this.reportGroups = res.data));
  },
  methods: {
    ...mapActions(["fetchReportGroups"]),
    containsSearch(value) {
      return (
        (value || "").toLowerCase().indexOf(this.search.toLowerCase()) > -1
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.groups-cont {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
}
.details-list {
  margin: 0;
  li::marker {
    color: var(--secondary-color);
  }
}
.category-icon {
  font-size: 0.8em;
}
.report-search {
  min-width: 300px;
}
.group-name {
  font-weight: bold;
}
.group-detail {
  padding-left: 10px;
}
.card {
  min-height: 300px;
}
@media (max-width: 1200px) {
  .groups-cont {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
